import React from "react";
import { useSelector } from "react-redux";
import useBackgroundMovieVideo from "../Hooks/useBackgroundMovieVideo";

const VideoBackground = ({ movieId }) => {
	const trailervideo = useSelector((store) => store.movies?.trailervideo);

	useBackgroundMovieVideo(movieId);

	return (
		<div className="w-screen">
			<iframe className="w-screen aspect-video"
				src={"https://www.youtube.com/embed/" + trailervideo?.key+"?&autoplay=1&mute=1"}
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
		</div>
	);
};

export default VideoBackground;
